import { lazy } from 'react';

import AuthGuard from 'components/AuthGuard';
import DashboardLayout from 'layouts/DashboardLayout';

const error404 = {
  component: lazy(() => import('views/Errors/Error404')),
};

const dashboardRoutes = {
  path: '/',
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: '/company',
      permission: 'company.select.getCompany',
      component: lazy(() => import('views/Company/Edit')),
    },
    {
      exact: true,
      path: '/dashboard',
      permission: 'dashboard.select.listDashboard',
      component: lazy(() => import('views/Dashboard')),
    },
    {
      exact: true,
      path: '/developers',
      permission: 'developers.select.listDevelopers',
      component: lazy(() => import('views/Developers/List')),
    },
    {
      exact: true,
      path: '/finance/billing',
      permission: 'billing.select.listBilling',
      component: lazy(() => import('views/Billing/List')),
    },
    {
      exact: true,
      path: '/movements/transactions',
      permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/Transactions/List')),
    },
    {
      exact: true,
      path: '/movements/transactions/:transactionId',
      permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/Transactions/Details')),
    },
    {
      exact: true,
      path: '/digital_payments/massive_payments',
      permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/MassivePayments')),
    },
    {
      exact: true,
      path: '/digital_payments/referenced_payments',
      permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/ReferencedPayments/List')),
    },
    {
      exact: true,
      path: '/notifications',
      permission: 'notifications.select.listNotifications',
      component: lazy(() => import('views/Notifications/List')),
    },
    {
      exact: true,
      path: '/digital_payments/payment_links',
      permission: 'paymentLink.select.listPaymentLink',
      component: lazy(() => import('views/PaymentLinks/List')),
    },
    {
      exact: true,
      path: '/digital_payments/payment_links/add',
      permission: 'paymentLink.insert.addPaymentLink',
      component: lazy(() => import('views/PaymentLinks/Edit')),
    },
    {
      exact: true,
      path: '/people/:peopleId',
      permission: 'people.select.getPeople',
      component: lazy(() => import('views/People/Details')),
    },
    {
      exact: true,
      path: '/access/roles',
      permission: 'roles.select.listRoles',
      component: lazy(() => import('views/Roles/List')),
    },
    {
      exact: true,
      path: '/access/roles/add',
      permission: 'roles.insert.addRoles',
      component: lazy(() => import('views/Roles/Edit')),
    },
    {
      exact: true,
      path: '/access/roles/:rolId',
      permission: 'roles.update.updateRoles',
      component: lazy(() => import('views/Roles/Edit')),
    },
    {
      exact: true,
      path: '/access/users',
      permission: 'users.select.listUsers',
      component: lazy(() => import('views/Users/List')),
    },
    {
      exact: true,
      path: '/access/users/:userId',
      permission: 'users.select.listApiKeys',
      component: lazy(() => import('views/Users/Edit')),
    },
    {
      exact: true,
      path: '/commerce',
      permission: 'commerces.select.listCommerces',
      component: lazy(() => import('views/Commerce/List')),
    },
    {
      exact: true,
      path: '/commerce/add',
      permission: 'commerces.insert.addCommerces',
      component: lazy(() => import('views/Commerce/Add')),
    },
    {
      component: lazy(() => import('views/Reports/List')),
      exact: true,
      path: '/reports',
      permission: 'reports.select.listReports',
    },
    {
      exact: true,
      path: '/sandbox/transactions',
      //permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/Sandbox/Transactions')),
    },
    {
      exact: true,
      path: '/sandbox/commerce',
      //permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/Sandbox/Commerce/List')),
    },
    {
      exact: true,
      path: '/sandbox/commerce/add',
      //permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/Sandbox/Commerce/Add')),
    },
    {
      exact: true,
      path: '/sandbox/test_matrix',
      //permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/Sandbox/TestMatrix')),
    },
    {
      exact: true,
      path: '/sandbox/cards',
      //permission: 'movements.select.listTransactions',
      component: lazy(() => import('views/Sandbox/Cards')),
    },
    
    error404,
  ],
};

export default dashboardRoutes;
